window.bindProductCarousel = function (root) {
  if (!root) return;
  var track = root.querySelector('[data-pc-track]');
  if (!track || track.dataset.bound === '1') return;
  track.dataset.bound = '1';

  var bar = root.querySelector('[data-pc-progress-bar]');
  var dragging = false;
  var didDrag = false;
  var startX = 0;
  var startScroll = 0;
  var activePointer = null;

  function visibleCount() {
    var styles = window.getComputedStyle(root);
    var columns =
      parseFloat(styles.getPropertyValue('--pc-columns')) ||
      parseFloat(styles.getPropertyValue('--rv-columns')) ||
      2;
    var peek =
      parseFloat(styles.getPropertyValue('--pc-peek')) ||
      parseFloat(styles.getPropertyValue('--rv-peek')) ||
      0;
    return columns + peek;
  }

  function scrollMax() {
    var list = track.querySelector('ul');
    var max = (list ? list.scrollWidth : track.scrollWidth) - track.clientWidth;
    if (max > 2) return max;
    max = track.scrollWidth - track.clientWidth;
    if (max > 2) return max;
    if (list && list.lastElementChild) {
      var last = list.lastElementChild;
      max = last.offsetLeft + last.offsetWidth - track.clientWidth;
    }
    return Math.max(0, max);
  }

  function update() {
    if (!bar) return;
    var max = scrollMax();
    var ratio = max <= 0 ? 0 : Math.min(1, track.scrollLeft / max);
    var slides =
      root.querySelectorAll('.product-carousel__slide, .recently-viewed__slide').length || 1;
    var thumb = Math.min(92, Math.max(18, (visibleCount() / slides) * 100));
    bar.style.width = thumb + (100 - thumb) * ratio + '%';
  }

  function stopDrag() {
    if (!dragging) return;
    dragging = false;
    activePointer = null;
    track.classList.remove('is-dragging');
    window.setTimeout(function () {
      didDrag = false;
    }, 0);
  }

  track.addEventListener(
    'pointerdown',
    function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest && event.target.closest('select, input, textarea, button')) return;
      dragging = true;
      didDrag = false;
      activePointer = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;
    }
  );

  window.addEventListener(
    'pointermove',
    function (event) {
      if (!dragging || event.pointerId !== activePointer) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) < 8) return;
      if (!didDrag) {
        didDrag = true;
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startScroll - delta;
    }
  );

  window.addEventListener('pointerup', stopDrag);
  window.addEventListener('pointercancel', stopDrag);

  track.addEventListener(
    'click',
    function (event) {
      if (!didDrag) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  track.addEventListener('dragstart', function (event) {
    if (didDrag) event.preventDefault();
  });

  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
};

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('product-recommendations.product-carousel, recently-viewed.product-carousel')
    .forEach(function (el) {
      window.bindProductCarousel(el);
    });
});
